import { useLazyQuery } from '@apollo/client';
import { IQueryResult, IVariables } from './interfaces';
import { paymentDelayGql } from './gql';

export type { IQueryResult } from './interfaces';

export const usePaymentDelayGql = () => {
  const [runPaymentDelayGql, { loading, data, error }] = useLazyQuery<IQueryResult, IVariables>(paymentDelayGql, {
    context: {
      headers: {
        userFunctionKey: '1ff1de774005f8da13f42943881c655f'
      }
    }
  });

  return {
    runPaymentDelayGql,
    loadingPaymentDelay: loading,
    dataPaymentDelay: data?.paymentDelay || [],
    errorPaymentDelay: error
  };
};
